import { render, staticRenderFns } from "./PagePerformanceReviewTemplates.vue?vue&type=template&id=08a727d7&"
import script from "./PagePerformanceReviewTemplates.vue?vue&type=script&lang=js&"
export * from "./PagePerformanceReviewTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports